import React from 'react';

const Footer = () => {

    const appVersion = document.getElementById("appVersion").value;

    return (
        <div>
            <div id="footer-bottom">
                <div className="container">
                    <div className="row no-gutters">
                        <div className="col-12 text-center">
                            <br />
                            <br />
                            <p>
                                {" "}
                                Desarrollado por: Logical Data, CR. Versión:{" "}
                                {appVersion} | Todos los Derechos Reservados |
                                Contáctenos:{" "}
                                <i class="fas fa-globe-americas"></i>
                                {" "}
                                <a href="http://www.ld.co.cr/" title="">
                                    {" "}
                                    http://www.ld.co.cr/{" "}
                                </a>
                                | <i class="fas fa-envelope"></i>{" "}
                                <a href="mailto:info@ld.co.cr">info@ld.co.cr</a>&nbsp;|&nbsp;
                                <i className="clip-phone-4"></i> +(506) 4052-2780
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;